"use strict";
export const CSRF_HEADER = "X-CSRF-Token";
export const CSRF_REFRESH_HEADER = "X-CSRF-Token-Refresh";
export const CSRF_REJECTED_HEADER = "X-CSRF-Rejected";
function csrfMeta() {
  var _a, _b;
  return (_b = (_a = document.head) == null ? void 0 : _a.querySelector('meta[name="csrf-token"]')) != null ? _b : null;
}
export function csrfToken() {
  const meta = csrfMeta();
  return meta && meta.content !== "" ? meta.content : null;
}
export function setCsrfToken(token) {
  const meta = csrfMeta();
  if (meta) {
    meta.content = token;
  }
}
